import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../utils/Helpers";
import UIButton from "../UIButton";

import "./UIPageFormFooter.scss";

const UIPageFormFooter = ({
  cancelLabel,
  submitLabel,
  onCancel,
  onSubmit,
  submitType,
  cancelDisabled,
  submitDisabled,
  submitLoading,
  className,
  cancelButtonProps = {},
  submitButtonProps = {},
}) => (
  <footer className={clx("ui-page-form-footer", className)}>
    <div className="ui-page-form-footer__actions">
      <UIButton
        type="button"
        variant="outline"
        size="medium"
        onClick={onCancel}
        disabled={cancelDisabled}
        {...cancelButtonProps}
      >
        {cancelLabel}
      </UIButton>
      <UIButton
        type={submitType}
        appearance="gradient"
        size="medium"
        onClick={onSubmit}
        disabled={submitDisabled}
        loading={submitLoading}
        {...submitButtonProps}
      >
        {submitLabel}
      </UIButton>
    </div>
  </footer>
);

UIPageFormFooter.propTypes = {
  cancelLabel: PropTypes.node.isRequired,
  submitLabel: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  submitType: PropTypes.oneOf(["button", "submit"]),
  cancelDisabled: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  submitLoading: PropTypes.bool,
  className: PropTypes.string,
  cancelButtonProps: PropTypes.object,
  submitButtonProps: PropTypes.object,
};

UIPageFormFooter.defaultProps = {
  onSubmit: undefined,
  submitType: "button",
  cancelDisabled: false,
  submitDisabled: false,
  submitLoading: false,
  className: "",
  cancelButtonProps: {},
  submitButtonProps: {},
};

export default UIPageFormFooter;
